import * as React from "react";
import { Tab } from "./tab";
import { utilRaiseError } from "./util/util";
import { FlexContainer } from "../grid/flexcontainer";
import { isNullOrUndefined } from "../better/utils";
import { css, cx } from "emotion";
import TabBar from "./tabbar";
const containerClass = css({
    width: "100%",
    height: "100%",
});
const tabPaneClass = css({
    display: "none",
    width: "100%",
    height: "100%",
});
const tabPaneIsActiveClass = css({
    display: "block",
});
export class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSelectedIndex: typeof props.selectedIndex === "number"
                ? props.selectedIndex
                : props.defaultSelectedIndex || 0,
        };
    }
    onClick(idx, tab) {
        return (event) => {
            if ((typeof this.props.selectedIndex === "number" &&
                idx !== this.props.selectedIndex) ||
                idx !== this.state.currentSelectedIndex) {
                this.setState({ currentSelectedIndex: idx });
                if (tab.props.onActive)
                    tab.props.onActive();
                this.props.onChange &&
                    this.props.onChange(idx, tab.props.value, tab, event);
            }
        };
    }
    render() {
        const tabs = React.Children.toArray(this.props.children);
        const tabItems = [];
        const panelElements = [];
        for (let idx = 0; idx < tabs.length; idx++) {
            const item = tabs[idx];
            if (typeof item === "object" &&
                !isNullOrUndefined(item) &&
                item.type === Tab) {
                const tab = item;
                const isActive = idx === this.state.currentSelectedIndex;
                tabItems.push({
                    label: tab.props.label,
                    onClick: this.onClick(idx, tab),
                });
                const classes = [tabPaneClass];
                isActive && classes.push(tabPaneIsActiveClass);
                panelElements.push(React.createElement("div", { key: idx, className: cx(classes) }, tab.props.children));
            }
            else {
                utilRaiseError("Expected Tabs only containing Tab elements");
            }
        }
        return (React.createElement("div", { className: cx(containerClass) },
            React.createElement(FlexContainer, { direction: "col", canShrink: false, gap: 12 },
                React.createElement(FlexContainer, { canGrow: false },
                    React.createElement(TabBar, { selectedIndex: this.state.currentSelectedIndex, small: this.props.small, justified: this.props.justified, tabItems: tabItems })),
                React.createElement(FlexContainer, { direction: "col" }, panelElements))));
    }
}
Tabs.defaultProps = {
    defaultSelectedIndex: 0,
    justified: false,
};
export default Tabs;
//# sourceMappingURL=tabs.js.map